import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade createNewModal",
  id: "EditUserAgenceModal",
  tabindex: "-1",
  ref: "addEditUserAgenceModalRef",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content p-15 p-md-40" }
const _hoisted_4 = { class: "modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25" }, [
          _createElementVNode("h5", { class: "modal-title fw-bold text-black" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", null, "Vous êtes sur le point d'affecter une nouvelle agence à: " + _toDisplayString($props.selectedUser?.nomComplet), 1),
          _createVNode(_component_Form, {
            ref: "agenceForm",
            onSubmit: _ctx.addAgence,
            "validation-schema": _ctx.agenceSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Nouvelle Agence ", -1)),
                    _createVNode(_component_Field, {
                      name: "nouvelleAgence",
                      modelValue: _ctx.agence,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agence) = $event))
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, {
                          options: _ctx.bureauxOptions,
                          onSelect: ($event: any) => (_ctx.getBureau(field.value)),
                          placeholder: "Selectionner une agence"
                        }), null, 16, ["modelValue", "onUpdate:modelValue", "options", "onSelect"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nouvelleAgence",
                      class: "text-danger"
                    })
                  ])
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("button", {
                  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16",
                  type: "submit"
                }, " Envoyer ", -1))
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("button", {
          type: "button",
          class: "btn-close shadow-none",
          "data-bs-dismiss": "modal",
          "aria-label": "Close"
        }, null, -1))
      ])
    ])
  ], 512))
}